/* Codex referans tasarımının etkileşim kodu.
   Not: Orijinal yakalama statik bir kopya olduğu için TÜM formların
   gönderimini engelliyordu. Bu, Dawn'ın sepet ve ödeme formlarını da
   kırdığı için engelleme yalnızca codex bölümlerindeki (.fadlen-cx)
   henüz bağlanmamış dekoratif formlarla sınırlandırıldı. */
document.querySelectorAll('.fadlen-cx form').forEach((form) => {
  if (form.closest('cart-drawer, #CartDrawer, form[action*="/cart"]')) return;
  if (form.getAttribute('action')) return; // gerçek bir hedefi varsa dokunma
  form.addEventListener('submit', (e) => e.preventDefault());
});

document.querySelectorAll('a[href="#"]').forEach((link) => link.addEventListener('click', (e) => e.preventDefault()));

document.querySelectorAll('.fadlen-search').forEach((search) => {
  search.addEventListener('toggle', () => {
    if (search.open) search.querySelector('input').focus();
  });
  search.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      search.open = false;
      search.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', (event) => {
    if (!search.contains(event.target)) search.open = false;
  });
});

const menuState = document.querySelector('#fm-menu-state');
const mobileMenu = document.querySelector('#fadlen-mobile-menu');
if (menuState && mobileMenu) {
  menuState.addEventListener('change', () => {
    const top = Math.max(0, document.querySelector('.fm-header').getBoundingClientRect().top);
    mobileMenu.style.top = top + 'px';
    mobileMenu.style.height = 'calc(100dvh - ' + top + 'px)';
    mobileMenu.style.maxHeight = 'calc(100dvh - ' + top + 'px)';
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') menuState.checked = false;
  });
  mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => (menuState.checked = false)));
  const mobileForm = mobileMenu.querySelector('form');
  if (mobileForm) mobileForm.addEventListener('submit', () => (menuState.checked = false));
  window.matchMedia('(min-width:1280px)').addEventListener('change', (e) => {
    if (e.matches) menuState.checked = false;
  });
}

/* ---------------------------------------------------------------
   Sepet: codex sepet butonlarını Dawn'ın sepet çekmecesine bağlar.
   Dawn yalnızca #cart-icon-bubble elemanına kendi tıklama olayını
   bağlar (masaüstü buton); mobildeki iki .fm-cart butonu ile sayaç
   eşitlemesi burada yapılır.
   --------------------------------------------------------------- */
(function () {
  const drawer = () => document.querySelector('cart-drawer');

  // Dawn'ın kendi bağladığı masaüstü butonu hariç, diğer tetikleyiciler
  document.querySelectorAll('[data-cart-trigger]').forEach((el) => {
    if (el.id === 'cart-icon-bubble') return; // Dawn zaten bağlıyor
    el.addEventListener('click', (event) => {
      const d = drawer();
      if (!d) return; // çekmece yoksa normal sepet sayfasına gitsin
      event.preventDefault();
      if (menuState) menuState.checked = false; // mobil menü açıksa kapat
      d.open(el);
    });
  });

  // Sayaç eşitleme: Dawn yalnızca #cart-icon-bubble içeriğini yeniler,
  // diğer rozetler buradan güncellenir.
  const bubble = document.getElementById('cart-icon-bubble');
  if (!bubble) return;

  const esitle = () => {
    const kaynak = bubble.querySelector('[data-cart-count]');
    if (!kaynak) return;
    const adet = (kaynak.textContent || '').trim();
    document.querySelectorAll('[data-cart-count]').forEach((rozet) => {
      if (rozet === kaynak) return;
      rozet.textContent = adet;
      if (!adet || adet === '0') rozet.setAttribute('hidden', '');
      else rozet.removeAttribute('hidden');
    });
  };

  new MutationObserver(esitle).observe(bubble, { childList: true, subtree: true, characterData: true });
  esitle();
})();
